import { render } from "./SubclassAddProductView.vue?vue&type=template&id=131b6f91"
import script from "./SubclassAddProductView.vue?vue&type=script&lang=js"
export * from "./SubclassAddProductView.vue?vue&type=script&lang=js"

import exportComponent from "/srv/git/index-webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__